// Formulare und Knöpfe mit data-confirm="Frage" fragen vor dem Absenden nach -
// etwa vor dem Löschen. Am Knopf gilt dessen Frage, sonst die des Formulars.
// Ohne JavaScript wird ohne Rückfrage abgeschickt.
export default function confirmSubmit() {
  // Capture: vor jedem anderen Submit-Handler (etwa dem XHR der Prompt-Kategorien).
  document.addEventListener('submit', function (event) {
    const form = event.target;
    const question = (event.submitter && event.submitter.dataset.confirm) || form.dataset.confirm;
    if (question && !window.confirm(question)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}
